var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaceSilhouette3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#0e1526;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 300,
    height: 300
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 138.25,
    y: 113.41,
    width: 31.5,
    height: 23.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M238.08,122.25a13.9,13.9,0,0,1,2-2.57c1.67-2.16,4.1-4.68,4.42-7.53.36-3.29-5.73-7.06-7.06-8.4-5.23-5.22-12.42-7.92-16.93-14a6.11,6.11,0,0,1-.77-5.77c.67-1.89,1.35-3,1.32-5.07a23.27,23.27,0,0,0-.88-5.61A54.33,54.33,0,0,0,216,62.88a69.43,69.43,0,0,0-10.92-15,98.34,98.34,0,0,0-13.29-12C174,22.68,154.46,20.49,133,21.84c-6,.37-12,.53-17.82,1.79C97.21,27.48,84.79,43.68,75.45,58.36,69.94,67,68.16,76.49,68.28,86.62c.11,8.78-.61,19.72,3.14,27.85,4.88,10.56,9.89,20.52,12,32.11,2.74,15.37,5.92,30,4.34,45.75a49.76,49.76,0,0,1-4.2,16c-5.08,10.87-15.48,20.45-24.3,28.26a159.83,159.83,0,0,0-21,22.56A165.11,165.11,0,0,0,15.48,300H207.35a246,246,0,0,0-21.72-25.77c-5.2-5.23-13.72-10.27-15.14-18.11s4.77-15.73,8.44-22.11c5.67-9.87,10.64-18.5,10.86-30,.3-16,8.44-18.32,22.57-18.59,3.33-.07,6.65.16,10,0,5.6-.25,15-.14,18.12-5.86,1.76-3.24.79-7.24,0-10.61-.65-2.91-2.48-7.63-1.74-10.63.51-2.05,2.32-3.46,3.32-5.25a11.3,11.3,0,0,0,1.08-5.71c0-4.14-2.68-6.21-1.83-6.33s1.34-1.46,2.07-2.68.61-4.87,0-6C242,129.77,236.71,125.56,238.08,122.25ZM174,139a2.13,2.13,0,0,1-2.12,2.13H136.12A2.13,2.13,0,0,1,134,139V111.29a2.12,2.12,0,0,1,2.12-2.13h3.06v-5.48a14.83,14.83,0,0,1,29.65,0v5.48h3a2.12,2.12,0,0,1,2.12,2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M164.58,103.68a10.58,10.58,0,0,0-21.15,0v5.48h21.15Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceSilhouette3);
export default __webpack_public_path__ + "static/media/face_silhouette_3.cf03445cd68283bf0971f7fc0f40ed34.svg";
export { ForwardRef as ReactComponent };